import React from 'react';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { useFluxoDeCaixa } from '../../hook/useFluxoDeCaixa';
import { ContainerTable } from './styles';

export const Table: React.FC = () => {
  const { rows, loading } = useFluxoDeCaixa();
  const columns: GridColumns = [
    {
      field: 'des_cc',
      headerName: 'Conta',
      sortable: false,
      headerAlign: 'center',
      hide: true,
      disableColumnMenu: true,
    },
    {
      field: 'dta_diario',
      headerName: 'Dia',
      sortable: false,
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 250,
      renderCell: (row) => {
        const { dta_diario, dia_semana } = row.row;
        return <span>{`${dta_diario}, (${dia_semana})`}</span>;
      },
    },
    {
      field: 'val_total_receber',
      headerName: 'Recebimentos',
      sortable: false,
      align: 'right',
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 280,
    },
    {
      field: 'val_total_pagar',
      headerName: 'Pagamentos',
      sortable: false,
      headerAlign: 'left',
      align: 'right',
      disableColumnMenu: true,
      width: 280,
    },
    {
      field: 'val_total_consolidado',
      headerName: 'Consolidado',
      align: 'right',
      sortable: false,
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 260,
    },
    {
      field: 'val_saldo',
      headerName: 'Saldo',
      headerAlign: 'left',
      sortable: false,
      align: 'right',
      disableColumnMenu: true,
      width: 282,
      headerClassName: 'hideRightSeparator',
      cellClassName: 'yellowCell',
    },
  ];

  return (
    <ContainerTable>
      <DataGrid
        style={{ minHeight: '380px' }}
        className="table"
        pageSize={5}
        rows={rows}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.dta_diario}
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </ContainerTable>
  );
};
